import { Input, QRCode } from 'antd';
import Modal from 'components/Modal';
import React from 'react';
import icon from 'shared/favicon/android-chrome-192x192.png';

const QRModal = ({ open, onCancel, value, size = 512 }) => (
  <Modal open={open} footer={null} onCancel={onCancel} width={size + 24 * 2} title="QR Code">
    {value && (
    <>
      <Input value={value} style={{ marginBottom: '1em' }} />
      <QRCode value={value} size={size} icon={icon} iconSize={64} />
    </>
    )}
  </Modal>
);

export default QRModal;
